<script>
import routes_mixin from "../../../mixins/routes_mixin";
import RouterLinkTo from "../../small_components/RouterLinkTo.vue";
import DefaultInput from "../../small_components/DefaultInput.vue";
import BadgeBlock from "../../slots/BadgeBlock.vue";
import EditIcon from "../../icons/EditIcon.vue";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../../store/modules/notifiocation";
import {mapActions} from "vuex";
import DefaultTitle from "../../small_components/DefaultTitle.vue";
import {axiosArticles, axiosUsers} from "../../../helpers/axios_requests";
import TextareaEditor from "../../small_components/TextareaEditor.vue";
import DefaultSelect from "../../small_components/DefaultSelect.vue";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../../small_components/DefaultButton.vue";
import { FORMAT_ERROR_MESSAGE } from '../../../helpers/validation_error_message';
import {NEW_ARTICLE} from "../../../helpers/new_objects";
import ImageComponent from "../../parts/ArticleImageComponent.vue";
import DefaultBox from "../../slots/DefaultBox.vue";
import Switcher from "../../small_components/Switcher.vue";

export default {
  name: 'ArticleView',
  components: {
    Switcher,
    DefaultBox,
    ImageComponent,
    DefaultButton,
    ValidationObserver,
    DefaultSelect, TextareaEditor, DefaultTitle, EditIcon, BadgeBlock, DefaultInput, RouterLinkTo},
  mixins: [routes_mixin],

  data() {
    return {
      getUserRoleIsAdmin: true,
      new_article: false,
      loading: true,
      article: [],
      categories: [],
      excludedUsers: [],
      users: [],
      selectedCategory: [],
    }
  },

  created() {
    this.loading = false;

    this.fetchArticle(this.get_id())
    this.fetchCategories()
    this.fetchUsers()
  },

  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.article = data || []
      if (data.category) {
        this.selectedCategory = data.category
      }
    },

    fetchArticle(id) {
      if (!id) {
        this.$set(this, 'article', NEW_ARTICLE())
        this.$set(this, 'new_article', true)
        return
      }
      this.loading = true
      axiosArticles.get(id)
          .then(r => {
            this.fillData(r.data.article)
          })
          .finally(() => {
            this.loading = false
          })
    },

    fetchCategories() {
      axiosArticles.getCategories()
          .then(r => {
            this.categories = r.data.collection;
          })
          .finally(() => {
            this.loading = false
          })
    },

    fetchUsers() {
      axiosUsers.list()
          .then(r => {
            this.users = r.data.collection;
          })
          .finally(() => {
            this.loading = false
          })
    },

    createUpdate() {
      this.loading = true
      if (
          typeof this.excludedUsers !== 'undefined' &&
          null !== this.excludedUsers
      ) {
        let usersArray = [];
        (this.excludedUsers || []).forEach(element => {
          usersArray.push(element.id);
        });
        this.user.committee.manager_of = managerArray;
      }
      axiosArticles.updateArticle(this.article)
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
      }).catch((r) => {
        console.log(r)
      }).finally(() => {
        this.loading = false
      })
    },

    changeCategory(value) {
      this.article.category_id = value.id
      this.selectedCategory = value
    },

    changeUsers(value) {
      this.excludedUsers = value
    },

    changePublished(value) {
      this.article.published = value.checked
    },

    changeUrgent(value) {
      this.article.urgent = value.checked
    },

    get_id() {
      return Number(this.$route.params.id)
    },
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
      <default-title h_tag="h3">
        {{ $t('articles.article_info') }}
      </default-title>
      <default-box class="position-relative"
                :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{ $t('articles.article') }} {{ article.title }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                <form class="row mt-20"
                      @submit.prevent="passes(createUpdate)">
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('articles.title')"
                        v-model="article.title"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('articles.subtitle')"
                        v-model="article.subtitle"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <default-select
                        :placeholder="$t('articles.category')"
                        :selected_val="selectedCategory"
                        display_item_api_key="title"
                        :list_outer="categories"
                        @change="changeCategory"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">

                    <template >
                      <image-component
                          :value.sync="article.image"
                          :id="article.id ?? 0">
                      </image-component>
                    </template>

                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <template v-if="new_article">
                      <textarea-editor
                          name="body"
                          :label="$t('articles.article_body')"
                          :init_mce="true"
                          v-model="article.body"
                      >
                      </textarea-editor>
                    </template>
                    <template v-if="article.body && !new_article">
                      <textarea-editor
                          name="body"
                          :label="$t('articles.article_body')"
                          :init_mce="true"
                          :value="article.body"
                          v-model="article.body"
                      >
                      </textarea-editor>
                    </template>
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                      <default-select
                          searchable
                          multiple
                          :placeholder="$t('articles.excluded')"
                          :selected_val="excludedUsers"
                          display_item_api_key="name"
                          :list_outer="users"
                          @change="changeUsers"
                      />

                  </div>
                  <div class="row mt-20 justify-content-end align-items-center">
                    <div class="col-md-2 col-2 mb-10">
                      <switcher
                          :placeholder="$t('articles.urgent')"
                          :checked="article.urgent"
                          @change="changeUrgent"
                      />
                    </div>
                    <div class="col-md-2 col-2 mb-10">
                      <switcher
                          :placeholder="$t('articles.publish')"
                          :checked="article.published"
                          @change="changePublished"
                      />
                    </div>
                    <div class="col-md-2 col-2 mb-10 text-endsticky-bottom">
                      <default-button
                          button_large
                          type="submit">
                        {{ $t('inputs.save') }}
                      </default-button>
                    </div>
                  </div>

                </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </default-box>
    </badge-block>
  </div>
</template>
